import { gql } from 'graphql.macro';

export const helpArticleTemplate = gql`
    query helpArticle($articleId: String!) {
        helpArticle(articleId: $articleId) {
            articleId
            title
            body
        }
    }
`;

export const searchHelpTemplate = gql`
    query searchHelp($query: String!, $tags: [String!]!) {
        searchHelp(query: $query, tags: $tags) {
            articleId
            title
        }
    }
`;

export const contextHelpTemplate = gql`
    query contextHelp($scopeTags: [String!]!, $urlTag: String!) {
        contextHelp(scopeTags: $scopeTags, urlTag: $urlTag) {
            articleId
            title
        }
    }
`;
